(function () {
  if (window.__collectionSlider) {
    window.__collectionSlider.initAll();
    return;
  }

  var instances = [];

  // Derive slides-per-view from actual rendered widths so a slider can opt into
  // a different column count (e.g. .cslider--four) purely via CSS.
  function perView(root, track, slides) {
    if (track && slides && slides.length) {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var slideWidth = slides[0].getBoundingClientRect().width;
      var trackWidth = track.clientWidth;
      if (slideWidth > 0 && trackWidth > 0) {
        return Math.max(Math.round((trackWidth + gap) / (slideWidth + gap)), 1);
      }
    }
    if (window.matchMedia('(min-width: 750px)').matches) return 3;
    if (window.matchMedia('(min-width: 500px)').matches) return 2;
    return 1;
  }

  function initSlider(root) {
    if (root.dataset.csliderInit === 'true') return;

    var track = root.querySelector('[data-cslider-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.cslider__slide'));
    var prevBtn = root.querySelector('[data-cslider-prev]');
    var nextBtn = root.querySelector('[data-cslider-next]');
    var dotsWrap = root.querySelector('[data-cslider-dots]');

    if (!track || slides.length === 0) return;
    root.dataset.csliderInit = 'true';

    function slideStep() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function positionCount() {
      return Math.max(slides.length - perView(root, track, slides) + 1, 1);
    }

    function maxIndex() {
      return positionCount() - 1;
    }

    function currentIndex() {
      var step = slideStep();
      return step > 0 ? Math.round(track.scrollLeft / step) : 0;
    }

    function scrollToIndex(i) {
      var idx = Math.min(Math.max(i, 0), maxIndex());
      track.scrollTo({ left: idx * slideStep(), behavior: 'smooth' });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var count = positionCount();
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'cslider__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () {
          scrollToIndex(parseInt(this.dataset.index, 10));
        });
        dotsWrap.appendChild(dot);
      }
    }

    function update() {
      var idx = Math.min(Math.max(currentIndex(), 0), maxIndex());
      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      }
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= maxIndex();
      
      root.classList.toggle('cslider--no-nav', slides.length <= perView(root, track, slides));
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(currentIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(currentIndex() + 1);
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    
    instances.push({
      rebuild: function () {
        buildDots();
        update();
      }
    });

    buildDots();
    update();
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var list = root.querySelectorAll('[data-cslider]');
    for (var i = 0; i < list.length; i++) {
      initSlider(list[i]);
    }
  }
  
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      for (var i = 0; i < instances.length; i++) {
        instances[i].rebuild();
      }
    }, 150);
  });
  
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.__collectionSlider = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }
})();